import { GameConstants } from "../../../GameConstants";
import { Button } from "../../../utils/Button";
import { GameVars } from "../../../GameVars";
import { GameManager } from "../../../GameManager";
import { GameOverPlayerAvatar } from "./GameOverPlayerAvatar";
import { AudioManager } from "../../../AudioManager";
import BattleUtils from "../../../gzp/BattleUtils";
import { BootScene } from "../../BootScene";

declare var gamezop: any;
declare var oMetaManager: any;
export class GameOverLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, timeout: boolean) {
        
        super(scene);

        this.alpha = 0;

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x1e4fa3, .175);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(background);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        const container = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "box_result");
        scaledItemsContainer.add(container);

        let winOrLoseSign = new Phaser.GameObjects.Image(this.scene, 0, -215, "texture_atlas_1", GameVars.playerData.id === GameVars.winningPlayerId  ? "txt_winner" : "txt_lose");
        scaledItemsContainer.add(winOrLoseSign);

        if (timeout) {

            winOrLoseSign.y = -225;

            const gameText = this.scene.game.cache.json.get("game-text");

            const timeoutMessage = new Phaser.GameObjects.Text(this.scene, 0, -178, GameVars.playerData.id === GameVars.winningPlayerId  ? gameText.OPPONENT_SKIPPED_TURN_GAME_OVER : gameText.SKIPPED_TURN_GAME_OVER, { fontFamily: "Arial", fontStyle: "bold", align: "center", fontSize: "24px", color: "#FFFFFF"});
            timeoutMessage.setOrigin(.5,BootScene.originY); 
            if(BootScene._isBrave) timeoutMessage.setLineSpacing(-400);
            scaledItemsContainer.add(timeoutMessage); 
        }

        const playerAvatar = new GameOverPlayerAvatar(this.scene, true);
        scaledItemsContainer.add(playerAvatar);

        const adversaryAvatar = new GameOverPlayerAvatar(this.scene, false);
        scaledItemsContainer.add(adversaryAvatar);

        const homeButton = new Button(this.scene, 0, 200, "texture_atlas_1", "btn_home_off", "btn_home_on");
        homeButton.onDown(this.onClickHome, this);
        scaledItemsContainer.add(homeButton);

        this.scene.add.tween({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450,
            delay: GameConstants.DEVELOPMENT ? 0 : 1500
        }); 

        setTimeout(() => {
            if (GameVars.playerData.id === GameVars.winningPlayerId) {
                AudioManager.playSound("win");
            } else {
                AudioManager.playSound("lose");
            }
        }, 1500);

        const stateScore: number = GameVars.playerData.id === GameVars.winningPlayerId ? 1 : 0;
        if (BattleUtils.doesBattleHasBots) {
            BattleUtils.sendBotBattleOverState(stateScore);
        }
        setTimeout(() => {
          gamezop.setState({
            state: "over",
            score: stateScore,
            metadata: oMetaManager.meta
          });
        }, 1000);
    }

    private onClickHome(): void {

        AudioManager.playSound("click_btn");
        
        GameManager.enterSplashScene();
    }
}
